function fnColorScheme() {
	const lightBlocks = Array.from(document.querySelectorAll('[data-light-scheme]'))

	if(!lightBlocks.length) return

	ScrollTrigger.create({
		trigger: 'main.base',
		start: 'top top',
		end: 'bottom bottom',
		invalidateOnRefresh: true,
		onUpdate: (self) => {
			const visibleEls = lightBlocks.filter((el) => ScrollTrigger.isInViewport(el, .3))
			
			if(visibleEls.length) {
				self.trigger.classList.add('light-scheme')
			} else {
				self.trigger.classList.remove('light-scheme')
			}
	}
	})
};
